export default {"src":"/_next/static/media/profileMenuBackground.abdef033.svg","height":169,"width":300};